;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockDonationForm from './BlockDonationForm';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockDonationForm(preview: $preview, id: $id) {
            __typename
            anchorId
            headline
            subHeadline {
                json
            }
            cta {
                ...CTA
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockDonationForm },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockDonationForm;
}

const BlockDonationFormServer = async ({ id }) => {
    const block = await fetchBlock(id);
    return <BlockDonationForm {...block} />;
};

export default BlockDonationFormServer;
